const reindex = (items, reindexKey) =>
  reindexKey
    ? items.map((item, i) => ({ ...item, [reindexKey]: i + 1 }))
    : items;

const clampIndex = (index, length) => Math.max(0, Math.min(index, length - 1));

/**
 * Pure array-reorder logic shared by drag-based and arrow-button reordering UIs.
 */
export const useReorderableList = (items, onChange, { reindexKey } = {}) => {
  const reorder = (from, to) => {
    if (from < 0 || from >= items.length) return;
    const clampedTo = clampIndex(to, items.length);
    if (clampedTo === from) return;

    const copy = [...items];
    const [moved] = copy.splice(from, 1);
    copy.splice(clampedTo, 0, moved);
    onChange?.(reindex(copy, reindexKey));
  };

  const moveUp = index => reorder(index, index - 1);
  const moveDown = index => reorder(index, index + 1);

  const canMoveUp = index => index > 0;
  const canMoveDown = index => index < items.length - 1;

  return { moveUp, moveDown, reorder, canMoveUp, canMoveDown };
};

export default useReorderableList;
